import { useState } from "react";
import { getRemediation } from "../wcag-data/remediation.js";

/**
 * Compact cause + before/after fix block for one violation. Shared by the
 * extension side panel and the web app issue view. Renders only engine
 * metadata and the already redacted snippet, never raw page content.
 */
export const FixSuggestion = ({ finding }) => {
  const fix = getRemediation(finding);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fix.after);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* clipboard unavailable; the code stays selectable */
    }
  };

  return (
    <div className="fixs-root" data-testid={`fix-suggestion-${finding.rule_id}`}>
      {fix.cause && <p className="fixs-cause">{fix.cause}</p>}

      {finding.snippet && (
        <>
          <span className="fixs-label">Affected element (redacted)</span>
          <code className="fixs-code" data-testid="fix-affected-element">{finding.snippet}</code>
        </>
      )}

      {fix.mapped ? (
        <>
          <span className="fixs-label">Before</span>
          <code className="fixs-code fixs-code-before" data-testid="fix-before-code">{fix.before}</code>
          <div className="fixs-head">
            <span className="fixs-label">After</span>
            <button type="button" className="fixs-copy" onClick={copy} data-testid="fix-copy-btn">
              {copied ? "Copied" : "Copy"}
            </button>
          </div>
          <code className="fixs-code fixs-code-after" data-testid="fix-after-code">{fix.after}</code>
          <p className="fixs-note">
            Generic corrected pattern for this rule. Adapt names and text to your markup.{" "}
            {finding.help_url && (
              <a className="fixs-link" href={finding.help_url} target="_blank" rel="noreferrer">
                Full rule guidance
              </a>
            )}
          </p>
        </>
      ) : (
        <p className="fixs-note" data-testid="fix-fallback-note">
          {finding.failure_summary && finding.failure_summary !== fix.cause ? `${finding.failure_summary} ` : ""}
          {finding.help_url && (
            <a className="fixs-link" href={finding.help_url} target="_blank" rel="noreferrer">
              How to fix this rule (axe-core guidance)
            </a>
          )}
        </p>
      )}
    </div>
  );
};
